<template>
	<div class="wuxing-page">
		<!-- 顶部导航栏 -->
		<div class="nav-bar">
			<img :src="logo" alt="五行商会" class="nav-logo" />
		</div>

		<!-- 余额卡片 -->
		<div class="balance-card">
			<img :src="balanceImg" alt="我的余额" class="balance-image" />
			<div class="balance-amount">{{ money | currency }}</div>
		</div>

		<!-- 提现进度标题 -->
		<div class="progress-header">
			<img :src="progressImg" alt="提现进度" class="progress-image" />
		</div>

		<!-- 列表区域：两列布局，左侧一列渲染所有时间节点，右侧一列渲染所有卡片 -->
		<div class="timeline-container two-col" v-if="showTimeline">
			<div class="timeline-left-col">
				<img :src="timeNodeImg" style="width: 35px;" alt="time node" />
			</div>
			<div class="timeline-right-col">
				<div class="timeline-card" v-for="(item, idx) in filteredItems" :key="'r' + idx">
					<img class="card-image" :src="getCardImage(item.file)" :alt="item.alt" @click="onAction(item)"
						:style="{ height: (item.file === '限额办卡前.png' || item.file === '限额办卡后.png') ? '140px' : '75px' }" />

					<!-- 仅当为 已申请提现金额.png 时显示汇总和最新时间 -->
					<div v-if="item.file === '已申请提现金额.png'" class="card-overlay">
						<div class="overlay-total">{{ tixianTotal | currency }}</div>
						<div class="overlay-time">{{ newTime }}</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 提示无提现记录的弹窗层 -->
		<div v-if="showNoRecordPopup" class="popup-overlay" @click="closeNoRecordPopup">
			<div class="no-record-popup-content" @click.stop>
				<div class="no-record-popup-text">
					<van-icon name="warning-o" class="warning-icon" />
					<span>请启用额度划转功能，<br />统一使用逐梦卡提现！</span>
				</div>
				<button class="no-record-popup-btn" @click="goToUser">立即提现</button>
			</div>
		</div>

		<!-- 放款失败弹窗层 -->
		<div v-if="showPopup" class="popup-overlay" @click="closePopup">
			<div class="popup-content" @click.stop>
				<img :src="popupImg" alt="弹窗" class="popup-image" @click="goToVerification" />
			</div>
		</div>
	</div>
</template>

<script>
	import Fetch from "../../utils/fetch";
	import logoImg from '@/assets/withdraws/logo.png'
	import balanceImg from '@/assets/withdraws/balance.png'
	import progressImg from '@/assets/withdraws/progress.png' // 新增 progress 图片
	import timeNodeImg from '@/assets/withdraws/timeNode.png'
	import popupImg from '@/assets/withdraws/popup2.png' // 新增弹窗图片

	export default {
		name: 'Withdraws',
		data() {
			return {
				logo: logoImg,
				money: 0,
				cashlenght: 0,
				is_account_verification: 0,
				is_claim_freeCard: 0,
				showTimeline: false,
				tixianTotal: 0,
				newTime: '',
				balanceImg: balanceImg,
				progressImg: progressImg, // 绑定进度图片
				timeNodeImg: timeNodeImg,
				popupImg: popupImg, // 弹窗图片
				balance: 0,
				showPopup: false, // 控制放款失败弹窗显示
				showNoRecordPopup: false, // 控制无提现记录弹窗显示
				// 列表项：图片名需与 assets/withdraws 下文件一致
				items: [{
						file: '已申请提现金额.png',
						alt: '已申请提现金额',
						key: 'applied'
					},
					{
						file: '待审核.png',
						alt: '待审核',
						key: 'pending'
					},
					{
						file: '审核通过.png',
						alt: '审核通过',
						key: 'approved'
					},
					{
						file: '放款失败前.png',
						alt: '放款失败前',
						key: 'failed'
					},
					{
						file: '放款失败后.png',
						alt: '放款失败后',
						key: 'failed'
					},
					{
						file: '身份验证前.png',
						alt: '身份验证前',
						key: 'verification'
					},
					{
						file: '身份验证后.png',
						alt: '身份验证后',
						key: 'verification'
					},
					{
						file: '身份验证完.png',
						alt: '身份验证完',
						key: 'verification'
					},
					{
						file: '限额办卡前.png',
						alt: '限额办卡前',
						key: 'verification'
					},
					{
						file: '限额办卡后.png',
						alt: '限额办卡后',
						key: 'verification'
					},
				],
				loading: false,
				error: null,
			}
		},
		created() {
			// 生命周期：创建时初始化数据
			this.$parent.footer('withdraws');
		},
		mounted() {
			this.start();
			this.cashSearch();
		},
		computed: {
			withdrawStatus() {
				return (this.$store && this.$store.state && this.$store.state.user && typeof this.$store.state.user
						.withdrawStatus !== 'undefined') ?
					this.$store.state.user.withdrawStatus :
					0;
			},
			filteredItems() {
				return this.items.filter(item => {
					const isVerified = this.is_account_verification === 1;
					const isClaimFreeCard = this.is_claim_freeCard === 1;

					// 已验证时过滤掉"前"图片
					if (isVerified && (item.file === '身份验证前.png' || item.file === '放款失败前.png')) {
						return false;
					}

					// 未验证时过滤掉"后"图片和相关图片
					if (!isVerified && (item.file === '身份验证后.png' || item.file === '放款失败后.png' ||
							item.file === '身份验证完.png' || item.file === '限额办卡前.png' ||
							item.file === '限额办卡后.png')) {
						return false;
					}

					// 已领取免费卡时过滤掉"前"图片
					if (isClaimFreeCard && item.file === '限额办卡前.png') {
						return false;
					}

					// 未领取免费卡时过滤掉"后"图片
					if (!isClaimFreeCard && item.file === '限额办卡后.png') {
						return false;
					}

					return true;
				});
			}
		},
		methods: {
			cashSearch() {
				Fetch('/user/cash_search')
					.then(r => {
						const data = r && r.data ? r.data : [];
						this.cashlenght = Array.isArray(data) ? data.length : 0;

						// 检查是否存在status为0的记录
						const hasStatusZero = Array.isArray(data) ?
							data.some(item => Number(item && item.status) === 0) : false;

						const shouldShow = hasStatusZero;

						const total = Array.isArray(data) ?
							data.reduce((sum, item) => {
								if (item && Number(item.status) === 0) {
									const m = Number(String(item.money || 0).replace(/[^0-9.-]+/g, ''));
									return sum + (isNaN(m) ? 0 : m);
								}
								return sum;
							}, 0) :
							0;
						this.tixianTotal = Math.round(total * 100) / 100;

						let latest = 0;
						data.forEach(item => {
							if (!item || Number(item.status) !== 0) return;
							const val = item.time;
							if (!val) return;
							let t = Number(val);
							if (isNaN(t)) t = Date.parse(val);
							if (!isNaN(t) && t > latest) latest = t;
						});
						this.newTime = latest ? new Date(latest).toLocaleString() : '';
						this.showTimeline = shouldShow;

						// 如果没有status为0的记录，才显示提示弹窗
						if (!hasStatusZero) {
							// 延迟显示弹窗，避免页面加载时立即弹出
							// setTimeout(() => {
							this.showNoRecordPopup = true;
							// }, 500);
						}
					})
					.catch(e => {
						console.error('Fetch /user/cash_search failed', e);
						this.showTimeline = false;
					});
			},
			start() {
				Fetch("/user/info").then((r) => {
					const raw = r && r.data && (r.data.money || r.data.balance || r.data.amount || 0);
					const num = Number(raw);
					this.money = isNaN(num) ? 0 : num;
					// 读取是否已通过账户验证（后端字段名可能为 is_account_verification）
					try {
						const accountVerification = r.data.is_account_verification;
						const claimFreeCard = r.data.is_claim_freeCard;
						this.is_account_verification = Number(accountVerification) === 1 ? 1 : 0;
						this.is_claim_freeCard = Number(claimFreeCard) === 1 ? 1 : 0;
					} catch (e) {
						this.is_account_verification = 0;
						this.is_claim_freeCard = 0;
					}
				}).catch(e => {
					console.error('Fetch /user/info failed', e);
				});
			},
			onAction(item) {
				console.log('action', item);

				// 1. 当点击已申请提现金额.png时，跳转到提现记录页面
				if (item.file === '已申请提现金额.png') {
					this.$router.push('/withdrawRecord');
					return;
				}

				// 2. 当点击放款失败前.png时，显示弹窗
				if (item.file === '放款失败前.png') {
					this.showPopup = true;
					return;
				}

				// 3. 点击身份验证前.png时，跳转到verification组件
				if (item.file === '身份验证前.png') {
					this.$router.push({
						name: 'verification',
						params: {
							type: item.key
						}
					});
					return;
				}

				// 4. 点击限额办卡前.png时，跳转到withdrawBankCard组件
				if (item.file === '限额办卡前.png') {
					this.$router.push('/withdrawBankCard');
					return;
				}

				// 4. 其他情况（待审核、审核通过、放款失败后、身份验证后）不跳转，只打印日志
				console.log('点击了非跳转图片:', item.file);
			},
			getCardImage(file) {
				try {
					return require(`@/assets/withdraws/${file}`)
				} catch (e) {
					console.warn('image not found:', file, e)
					return ''
				}
			},
			// 关闭放款失败弹窗
			closePopup() {
				this.showPopup = false;
			},
			// 关闭无提现记录弹窗
			closeNoRecordPopup() {
				this.showNoRecordPopup = false;
			},
			// 点击弹窗图片跳转到verification组件
			goToVerification() {
				this.showPopup = false;
				this.$router.push({
					name: 'verification',
					params: {
						type: 'failed'
					}
				});
			},
			// 点击立即提现按钮跳转到user组件
			goToUser() {
				this.closeNoRecordPopup();
				// 跳转到user组件，这里假设路由名为'user'，请根据实际路由配置调整
				this.$router.push('/user');
				// 或者使用命名路由（如果配置了的话）
				// this.$router.push({ name: 'user' });
			}
		},
		filters: {
			currency(val) {
				if (val == null) return '¥0.00';
				return '¥' + Number(val).toFixed(2);
			}
		}
	}
</script>

<style lang="less" scoped>
	/* 全局容器：模拟红色背景图 */
	.wuxing-page {
		height: 100%;
		background-image: url('../../assets/withdraws/withdraws-bg.png');
		background-size: cover;
		background-position: center;
		padding: 20px;
		font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
		color: #333;
		position: relative;
		overflow: hidden;
	}

	/* 顶部导航 */
	.nav-bar {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 12px 0;
		margin-bottom: 16px;
	}

	.nav-logo {
		height: 70px;
		/* 根据需要调整高度 */
		width: auto;
		object-fit: contain;
		display: block;
	}

	.back-icon {
		font-size: 24px;
		margin-right: 15px;
	}

	.brand {
		display: flex;
		align-items: center;
	}

	.logo-placeholder {
		width: 40px;
		height: 40px;
		border: 2px solid #f1c40f;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 10px;
		color: #f1c40f;
		margin-right: 10px;
	}

	.brand-text .cn {
		font-size: 18px;
		font-weight: bold;
	}

	.brand-text .en {
		font-size: 12px;
		opacity: 0.8;
	}

	.watermark-logo {
		position: absolute;
		right: 20px;
		top: 50%;
		transform: translateY(-50%);
		width: 50px;
		height: 50px;
		border: 3px solid rgba(255, 215, 0, 0.5);
		border-radius: 50%;
	}

	/* 进度标题 */
	.progress-header {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 10px 0 16px;
	}

	.progress-image {
		width: 200px;
		/* 你要的固定宽度 */
		max-width: 90%;
		height: auto;
		display: block;
	}

	/* 小屏微调 */
	@media (max-width: 400px) {
		.progress-image {
			width: 240px;
		}
	}

	/* 余额卡片：图片居中，固定尺寸（px），小屏自适应 */
	.balance-card {
		display: flex;
		justify-content: center;
		align-items: center;
		/* padding: 12px; */
		margin-bottom: 24px;
		/*background: rgba(255,255,255,0.08); 可按需去掉，图上会有背景 */
		border-radius: 12px;
		position: relative;
		overflow: hidden;
	}

	.balance-image {
		width: 90%;
		height: 90px;
		object-fit: contain;
		display: block;
	}

	.balance-amount {
		position: absolute;
		left: 25px;
		bottom: 12px;
		color: #ffffff;
		padding: 6px 10px;
		border-radius: 6px;
		font-size: 18px;
		font-weight: 700;
		line-height: 1;
		pointer-events: none;
	}

	.card-overlay {
		position: absolute;
		left: 112px;
		bottom: 6px;
		color: #000000;
		padding: 6px 10px;
		border-radius: 6px;
		font-size: 12px;
		font-weight: 700;
		line-height: 1.2;
		pointer-events: none;
	}

	@media (max-width: 420px) {
		.balance-amount {
			left: 25px;
			bottom: 10px;
			font-size: 16px;
		}
	}

	/* 时间线样式 */
	.timeline-container {
		margin-top: 8px;
		margin-bottom: 60px;
	}

	.two-col {
		display: flex;
		// gap: 12px;
	}

	.timeline-left-col,
	.timeline-right-col {
		display: flex;
		flex-direction: column;
		gap: 14px;
	}

	.timeline-left-col {
		width: 60px;
		/* 左侧固定列 */
		align-items: center;
	}

	.timeline-left-col .timeline-node img {
		width: 28px;
		height: 28px;
		display: block;
	}

	.timeline-right-col {
		flex: 1;
	}

	.timeline-card {
		display: flex;
		align-items: center;
		position: relative;
	}

	.card-image {
		width: 330px;
		// height: 75px;
		object-fit: cover;
		border-radius: 8px;
		cursor: pointer;
	}

	@media (max-width: 420px) {
		// .card-image {
		// 	width: 330px;
		// 	height: 75px;
		// }

		.timeline-left-col {
			// width: 48px;
			width: 25px;
		}

		.timeline-left-col .timeline-node img {
			width: 22px;
			height: 22px;
		}
	}

	/* 弹窗样式 */
	.popup-overlay {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 1000;
	}

	.popup-content {
		padding: 20px;
		border-radius: 12px;
	}

	.popup-image {
		max-width: 90vw;
		max-height: 80vh;
		cursor: pointer;
		border-radius: 8px;
	}

	/* 无提现记录弹窗样式 */
	.no-record-popup-content {
		background-color: white;
		padding: 30px 25px;
		border-radius: 12px;
		width: 80%;
		max-width: 320px;
		text-align: center;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	}

	.no-record-popup-text {
		font-size: 16px;
		color: #333;
		margin-bottom: 25px;
		line-height: 1.4;
		font-weight: 500;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		gap: 8px;
	}

	.warning-icon {
		color: #ff4444;
		font-size: 2rem;
	}

	.no-record-popup-btn {
		background-color: #f1c40f;
		color: white;
		border: none;
		border-radius: 25px;
		padding: 12px 30px;
		font-size: 16px;
		font-weight: bold;
		cursor: pointer;
		width: 100%;
		transition: background-color 0.3s;
	}

	.no-record-popup-btn:hover {
		background-color: #e0b90f;
	}

	.no-record-popup-btn:active {
		background-color: #d0a90e;
	}
</style>